import { IrrigationEventProto } from "./IrrigationEventProto.js";

export class SetIrrigationEvent extends IrrigationEventProto {
    type: "set" | "single" | "repeating" | "csv" = "set";
    constructor(props, manualLoad = false) {
        super(props, true);
        this.category = "setIrrigationEvent";
        this.type = "set";
        if (!manualLoad) {
            this.load().catch(() => {});
        }
    }

    async load() {
        this.type = "set";
        await super.load();
        this.type = "set";
    }
    /**
     * ZoneAPI object being assigned to
     * @type {IrrigationSet}
     */
    set = undefined;
    get zoneID() {
        if (this.zone) {
            return this.zone.dbID;
        } else if (this.set) {
            return this.set.dbID;
        } else {
            return undefined;
        }
    }
}
